import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch('https://readdy.ai/api/form/d7d53lhnoju8nk5a14m0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubscribed(true);
      setEmail('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#0d1f3c] text-white">
      {/* Newsletter Banner */}
      <div className="bg-[#0a1a30] border-b border-white/10 py-10 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-blue-200 mb-1">Newsletter</p>
            <h3 className="text-xl md:text-2xl font-bold text-white">Receba análises e dicas diretamente no seu email</h3>
          </div>
          {subscribed ? (
            <div className="flex items-center gap-2 text-green-300 font-semibold">
              <i className="ri-checkbox-circle-line text-xl"></i>
              Subscrito com sucesso!
            </div>
          ) : (
            <form
              data-readdy-form
              onSubmit={handleNewsletter}
              className="flex gap-2 w-full md:w-auto"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="O seu email..."
                required
                className="flex-1 md:w-72 px-4 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-white/60"
              />
              <button
                type="submit"
                disabled={submitting}
                className="bg-white text-blue-700 font-bold px-6 py-3 rounded-full text-sm hover:bg-blue-50 transition-all whitespace-nowrap cursor-pointer"
              >
                {submitting ? 'A enviar...' : 'Subscrever'}
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="lg:col-span-1">
          <img
            src="https://public.readdy.ai/ai/img_res/6747dcc7-b124-4feb-be6c-83706c4a2b6a.png"
            alt="FuturosPro"
            className="h-10 w-auto object-contain mb-4"
          />
          <p className="text-slate-400 text-sm leading-relaxed mb-5">
            O seu guia de referência para trading de futuros em Prop Firms. Análises imparciais, estratégias comprovadas e conteúdo educacional.
          </p>
          <div className="flex gap-3">
            {['ri-youtube-line', 'ri-twitter-x-line', 'ri-instagram-line', 'ri-telegram-line'].map((icon) => (
              <a key={icon} href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-slate-300 hover:bg-blue-600 hover:text-white transition-all cursor-pointer">
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Links 1 */}
        <div>
          <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">Prop Firms</h4>
          <ul className="space-y-2.5">
            {['Comparação Geral', 'FTMO', 'The Funded Trader', 'MyForexFunds', 'Topstep', 'Apex Trader'].map((item) => (
              <li key={item}>
                <Link to="/comparacao" className="text-slate-400 text-sm hover:text-blue-400 transition-colors cursor-pointer">{item}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Links 2 */}
        <div>
          <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">Trading</h4>
          <ul className="space-y-2.5">
            {['Estratégias', 'Artigos Gerais', 'Trading Live', 'Psicologia', 'Gestão de Risco', 'Melhores Ativos'].map((item) => (
              <li key={item}>
                <Link to="/estrategias" className="text-slate-400 text-sm hover:text-blue-400 transition-colors cursor-pointer">{item}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Links 3 */}
        <div>
          <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">Empresa</h4>
          <ul className="space-y-2.5">
            {[
              { label: 'Sobre Nós', path: '/sobre' },
              { label: 'Contactos', path: '/contactos' },
              { label: 'Política de Privacidade', path: '/sobre' },
              { label: 'Termos e Condições', path: '/sobre' },
              { label: 'Disclosure de Afiliados', path: '/sobre' },
            ].map((item) => (
              <li key={item.label}>
                <Link to={item.path} className="text-slate-400 text-sm hover:text-blue-400 transition-colors cursor-pointer">{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/10 py-6 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>&copy; 2026 FuturosPro. Todos os direitos reservados.</p>
          <p className="text-center">
            <strong className="text-slate-400">Aviso:</strong> Trading envolve risco. Este site contém links de afiliado. Leia o nosso{' '}
            <Link to="/sobre" className="text-blue-400 hover:underline cursor-pointer">Disclosure de Afiliados</Link>.
          </p>
        </div>
      </div>
    </footer>
  );
}
